module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "rgb(189, 214, 236)",
      "padding": "15px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('input-box-result', {
      key: f.name,
      attrs: {
        "value": _vm.dataValues[f.name],
        "label": f.label
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('input-box-result', {
      key: f.name,
      attrs: {
        "labelSize": "L",
        "value": _vm.dataValues[f.name],
        "label": f.label
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('input-box-result', {
      key: f.name,
      attrs: {
        "value": _vm.dataValues[f.name],
        "label": f.label
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4da7ab4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report_totals_box.vue
// module id = 1054
// module chunks = 0